import { ApplicationRef, Component, ComponentFactoryResolver, ComponentRef, ElementRef, Injector, Input, OnInit, SimpleChanges } from '@angular/core';
import { Constructor } from '@skylab-shared/types';
import { ListenersRegistry } from '@skylab-shared/utils';
import { getComponentRefElement } from '../utils/component-ref-element';
import { $ } from '../utils/element';

export interface IComponentWrapper {
    data: unknown;
}

@Component({
    selector: 'skl-wrapper',
    template: ''
})
export class WrapperComponent<TData> extends ListenersRegistry(class {}) implements OnInit, IComponentWrapper {
    @Input() public data!: TData;
    @Input() public component!: Constructor<IComponentWrapper>;
    private componentRef!: ComponentRef<IComponentWrapper> | null;

    public constructor(
        private elRef: ElementRef,
        private componentFactoryResolver: ComponentFactoryResolver,
        private injector: Injector,
        private appRef: ApplicationRef) {
            super();
        }

    public ngOnInit(): void {
        this.componentRef = this.componentFactoryResolver.resolveComponentFactory(this.component).create(this.injector);
        this.componentRef.instance.data = this.data;
        this.appRef.attachView(this.componentRef.hostView);
        this.registerListening(() => {
            if (this.componentRef) {
                this.appRef.detachView(this.componentRef.hostView);
                this.componentRef.destroy();
            }
        });
        this.componentRef.changeDetectorRef.detectChanges();
        const componentElement = getComponentRefElement(this.componentRef.hostView);
        $(this.elRef.nativeElement).append(componentElement.element);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (this.componentRef?.instance && !changes['data']?.firstChange) {
            this.componentRef.instance.data = {...this.data};
            this.componentRef.changeDetectorRef.detectChanges();
        }
    }

    public ngOnDestroy(): void {
        this.deregisterAllListeners();
        this.componentRef = null;
    }
}
